import classNames from "classnames";
import useTranslation from 'next-translate/useTranslation';

import utilStyles from 'styles/utils.module.scss';
import styles from 'components/layout/TopBar/search.module.scss';
import SearchIcon from 'images/icons/search.svg';
import {useEffect, useRef, useState} from "react";
import {useRouter} from "next/router";
import CloseIcon from "images/icons/close.svg";


export default function Search(props) {
    const { t } = useTranslation('layout-TopBar-Search');
    const {searchText, setSearchText, placeholder} = props;
    const onSubmit = props.onSubmit || function () {
    };
    const [isFocused, setIsFocused] = useState(false);
    const [inputText, setInputText] = useState(searchText);

    const router = useRouter();

    const onTextChange = (newText) => {
        setSearchText(newText);
    };

    const debounceRef = useRef(null);
    const debounceTextChange = () => {
        console.log('debounceTextChange')
        setInputText(inputRef.current.value);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            onTextChange(inputRef.current.value);
        }, 500);
    };

    const inputRef = useRef(null);
    const formRef = useRef(null);

    const onDivClick = () => {
        setSearchText('');
    };

    useEffect(() => {
        inputRef.current.value = searchText;
        setInputText(searchText);
    }, [searchText]);

    const handleSubmit = () => {
        const query = inputRef.current.value;
        setIsFocused(false);
        console.log('onSubmit', query);
        inputRef.current.blur();
        onSubmit(query);
        typeof mixpanel !== 'undefined' && mixpanel.track("SearchSubmit", {query});

    };

    const resetInput = () => {
        inputRef.current.value = '';
        inputRef.current.focus();
        setInputText('');
        onTextChange('');
    };

    return (
        <div
            className={classNames(utilStyles.fullWidth, styles.container, utilStyles.justifyContentSpaceBetween, utilStyles.alignItemsCenter, isFocused ? styles.focusedContainer : undefined)}>
            <form onSubmit={e => {
                e.preventDefault();
                handleSubmit();
            }} style={{width: '100%'}} ref={formRef}>
                <div className={styles.searchInputWrapper}>
                    <SearchIcon viewBox="0 0 24 24" className={styles.searchIcon}/>
                    <input type="text" placeholder={placeholder || t('Search.placeholder')}
                           className={classNames(styles.input, isFocused ? styles.focusedInput : undefined)}
                           onChange={debounceTextChange}
                           onFocus={() => {
                               setIsFocused(true);
                           }}
                           onBlur={() => {
                               setIsFocused(false);
                           }}
                           autoFocus={props.autoFocus}
                           ref={inputRef}
                    />
                    {
                        inputText && inputText.length > 0 &&
                        <CloseIcon className={styles.closeIcon} onClick={resetInput} />
                    }
                    <input type={"submit"} style={{display: "none"}}/>
                </div>
            </form>
        </div>
    )
}
